import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { OptionTemplateService } from '@app/features/system-settings/option-template/services/option-template.service';
import { ProposalTemplateService } from '@app/features/system-settings/proposal-template/services/proposal-template.service';
import {AuthService} from "@app/core";
declare var $: any;
import {FolderService} from "@app/shared/common-folder-structure/service/folder.service";

@Component({
	selector: 'app-add-addon-modal',
	templateUrl: './add-addon-modal.component.html',
	styleUrls: ['./add-addon-modal.component.scss']
})
export class AddAddonModalComponent implements OnInit {
	public onClose: Subject<any>;
	title: string;
	lastPg: any;
	isOptionTemplate: any;
	additionalInformation: any;
	addOnTemplates: any[];
	addonType: string = 'template';
	addonForm: FormGroup;
	editAddon: boolean = false;
	selectedTemplate: any;
	opportunityId: any;
    opportunityProposalId: any;
	action: string = 'save';
	select2: boolean = false;
	template: any;
	select2TemplateConfig: any;
	selectedAddon: any;
	optionsData: any[] = [];
	editorAddon: boolean = false;
    subscriptions: object = {};
    templatesLoading: boolean = true;
	showAddOnTemplate:boolean = true;
	additionalInfo:any;
    isViewMode:boolean = false;
    freemiumAccess:boolean = false;
    showAddNewTemplate:boolean = false;
    excludeOptions:any = [];
    showDefect:boolean = false;
    select2DefectConfig: {};
    customerId:any;
    defectListData:any;
    defectSaveEnable:boolean = false;
    pageId:any;
    defectId:any;
    defectDescription:any;
    labelName:string='';
    editOrAddDefectRecommendation = false;
    showAddon = false;
    marketPlaceData:any;
    blankOption: boolean;
    addMarketPlaceOption: boolean;
    addonData: any[];

    templateId: any;
    templateType: any;
    pageContentHTML:any;
    isFreemium:boolean;
    templateName:any;
    isAddTemplateModal:boolean = false;
    optionNameToDisplayNewDisplay:string = '';
    validationMessage:any;
    uniqueName:boolean = false;
    customTagAccess:boolean = false;
    originalProposalPages:any;
	constructor(private fb: FormBuilder,
		public bsModalRef: BsModalRef,
		public optionTemplateService: OptionTemplateService,
		public proposalTemplateService: ProposalTemplateService,
                private authService: AuthService,private templateService: FolderService,) { }

	ngOnInit() {
        if(!this.showAddOnTemplate) {
            this.addonType = 'blank'
        }
        this.labelName = this.isAddTemplateModal ? 'Name' : this.editOrAddDefectRecommendation || this.showDefect ? 'Description' : 'add-on.name';
        this.validationMessage = this.isAddTemplateModal ? 'Please.enter.valid.template.name' : 'Please.enter.valid.addon.name';
        this.showAddon = this.showAddon ? true : this.editAddon;
        let proposalEditor = this.authService.permitted(['AdvancedProposalEditor.readaccess']) === true;
        if(!proposalEditor){
            this.freemiumAccess = true
        } else {
            this.freemiumAccess = false
        }
		this.proposalTemplateService.templateName$.subscribe(template => {
			this.template = template;
		});
        this.getDefectsList();
		this.onClose = new Subject();
		this.buildForm();
		if (this.editorAddon) {
			this.getAllTemplates();
		}
		if (this.selectedAddon && this.selectedAddon.hasOwnProperty('addOnName')) {
			this.addonForm.controls.optionName.setValue(this.selectedAddon.addOnName);
		}
        if (this.selectedAddon && this.selectedAddon.hasOwnProperty('customerOptionName')) {
            this.addonForm.controls.customerOptionName.setValue(this.selectedAddon.customerOptionName);
        }
        if (this.selectedAddon && this.selectedAddon.hasOwnProperty('defectRecommendationList')) {
            this.addonForm.controls.customerOptionName.setValue(this.selectedAddon.defectRecommendationList);
        }
        if (!this.defectSaveEnable){
            this.addonForm.get('defectRecommendationList').setValidators(null);
            this.addonForm.get('defectRecommendationList').setErrors(null);
        }
        this.isViewMode = this.isViewMode;
        if(this.freemiumAccess){
            setTimeout( ()=>{
                this.addonType = 'template';
            },400)
        }
        this.blankOption = true;
        this.addMarketPlaceOption = false;
        setTimeout(() => {
            $('.blank-image').addClass('selected-image');
        },200)
	}

    checkUniqueName(value,isAddTemplateModal){
        if(isAddTemplateModal){
            let params: any;
            if (this.templateType === 'option'){
                params = {
                    optionName: value.target.value,
                    isAddonTemplate: this.optionNameToDisplayNewDisplay && this.optionNameToDisplayNewDisplay.includes('Add-on') ? "true" : "false",
                    variation: false
                };
                this.templateService.checkTemplateName(params).subscribe(resp => {
                    this.uniqueName = resp == true;
                    if (this.uniqueName){
                        this.addonForm.setErrors({invaild:true});
                    }else{
                        this.addonForm.setErrors(null);
                    }
                });
            }else{
                params = {
                    template: value.target.value
                };
                this.templateService.checkProposalTemplateExists(params).subscribe(resp => {
                    this.uniqueName = resp == true;
                    if (this.uniqueName){
                        this.addonForm.setErrors({invaild:true});
                    }else{
                        this.addonForm.setErrors(null);
                    }
                });
            }
        }
    }

    getDefectsList()
    {
        let details = {'screenType':'proposal'};
        this.optionTemplateService.getDefectListCustomer(this.customerId,details).subscribe((res:any)=>{
            this.defectListData = res.data;
        });
    }
    initializeSelect2(optionTemplates) {
        let dataToSet = [];

        if(optionTemplates && optionTemplates.length) {
            optionTemplates.forEach((item: any) => {
                dataToSet.push({
                    id: parseInt(item.id),
                    text: item.optionName
                })
            });
        }

        this.select2TemplateConfig = {
            width: '100%',
            data: dataToSet
        }
        this.templatesLoading = false;
    }
    getSelectedDefect(event){
        this.addonForm.get('defectRecommendationList').setValue(event);
        this.addonForm.get('optionName').setValidators(null);
        this.addonForm.get('optionName').setErrors(null);
        this.defectSaveEnable = true;
        this.defectListData.map(item =>{
            if (item.id == event){
                this.defectId = item.id;
                this.defectDescription = item.description;
            }
        })
    }
    getAllTemplates() {
        this.additionalInfo['type'] = 'addon';
        this.subscriptions['optionsList'] = this.optionTemplateService.getAllOptionTemplates(this.additionalInfo).subscribe(data => {
            if (data) {
                this.showAddOnTemplate = true;
                for (let index = 0; index < data['excludeOptions'].length; index++) {
                    if(data['excludeOptions'][index]['addon'] == 1) {
                        this.excludeOptions.push(data['excludeOptions'][index]['id']);
                    }
                }
            }
        })
    }

	// Form buildForm
	buildForm() {
		this.addonForm = this.fb.group({
			'id': [''],
			'optionName': ['', Validators.required],
            'customerOptionName': [''],
            'defectRecommendationList':['',Validators.required]
		})
	}

    get f() {
        return this.addonForm.controls;
    }
	// submit option
	save(optionType) {
		let addInfo = this.additionalInformation;
		let opportunityIdVal = '';
        let opportunityProposalIdVal = '';
		let proposalTemplatesIdVal = '';
		let setupOptionIdVal = '';
		let selectedType = '';
		let pageNumber = '';
		let formValue = this.addonForm.value;
        if(!this.showAddOnTemplate) {
            optionType = 'blank'
        }
		if (this.editorAddon) {
			if (this.selectedTemplate == 'proposal') {
				proposalTemplatesIdVal = this.template.id;
			} else if (this.selectedTemplate == 'option') {
				setupOptionIdVal = this.template.id;
			} else {
				opportunityIdVal = this.opportunityId;
                opportunityProposalIdVal = this.opportunityProposalId;
			}
			selectedType = this.selectedTemplate;
			pageNumber = this.lastPg;
            if (optionType == 'blank') {
                let option = {
                    "opportunityId": opportunityIdVal,
                    'opportunityProposalId': opportunityProposalIdVal,
                    "selectedTemplate": selectedType,
                    "proposalTemplateId": proposalTemplatesIdVal,
                    "setupOptionId": setupOptionIdVal,
                    "setupOption": {
                        "optionName": formValue.optionName,
                        "customerOptionName": formValue.customerOptionName,
                    },
                    "addOn": 'true',
                    "lastPageNumber": pageNumber
                }
                if(this.blankOption && !this.addMarketPlaceOption){
                    this.saveAddon(option);
                }
                else if (!this.blankOption && this.addMarketPlaceOption) {
                    this.saveMarketplaceOption(option);
                }
            }
            else {
                let option = {
                    "opportunityId": opportunityIdVal,
                    'opportunityProposalId': opportunityProposalIdVal,
                    "selectedTemplate": selectedType,
                    "proposalTemplateId": proposalTemplatesIdVal,
                    "setupOptionId": setupOptionIdVal,
                    "optionTemplateId": formValue.optionName,
                    "customerOptionName": formValue.customerOptionName,
                    "addOn": 'true',
                    "lastPageNumber": pageNumber
                }
                this.saveAddon(option);
            }
            this.action = 'saving';
		}
		else {
			if (!this.editAddon) {
				this.action = 'saving';
				let option: any;
				if (optionType == 'blank') {
                    if (this.isAddTemplateModal == true){
                        let pageDetails = { 'templateId': this.templateId,
                            'templateType': this.templateType,
                            'pageId':this.pageId,
                            'pageContent': this.pageContentHTML,
                            'type':'add',
                            'isFreemium':this.isFreemium,
                            'templateName':this.addonForm.controls.optionName.value,
                            'customerDisplayName': this.addonForm.controls.customerOptionName.value,
                            'opportunityProposalId':this.opportunityProposalId,
                            'addOn': this.optionNameToDisplayNewDisplay.includes('Add-on'),
                            'customTagAccess':this.customTagAccess,
                            'originalProposalPages':this.originalProposalPages
                        }
                        if(this.templateType === 'option'){
                            pageDetails['variationOption'] = null;
                        }
                        this.proposalTemplateService.editProposalTemplate(this.templateId,pageDetails).subscribe((res)=>{
                            if (res){
                                this.action = 'save';
                                this.onClose.next(true);
                                this.bsModalRef.hide();
                            }
                        });
                    }else{
                        let defectOption;
                        if (this.defectSaveEnable){
                            defectOption ={
                                "pageId":this.pageId,
                                "defectDescription":this.defectDescription,
                                "defectId":this.defectId
                            }
                        }
                        if (addInfo) {
                            opportunityIdVal = addInfo.hasOwnProperty('opportunityId') && addInfo.opportunityId > 0 ? addInfo.opportunityId : '';
                            opportunityProposalIdVal = addInfo.hasOwnProperty('opportunityProposalId') && addInfo.opportunityProposalId > 0 ? addInfo.opportunityProposalId : '';
                            proposalTemplatesIdVal = addInfo.hasOwnProperty('proposalTemplatesId') && addInfo.proposalTemplatesId > 0 ? addInfo.proposalTemplatesId : '';
                            setupOptionIdVal = addInfo.setupOptionId;
                            selectedType = addInfo.selectedTemplate;
                            pageNumber = addInfo.pageNumber;
                        }
                        option = {
                            "opportunityId": opportunityIdVal,
                            'opportunityProposalId': opportunityProposalIdVal,
                            "selectedTemplate": selectedType,
                            "proposalTemplateId": proposalTemplatesIdVal,
                            "setupOptionId": setupOptionIdVal,
                            "setupOption": {
                                "optionName": this.defectSaveEnable ? '' : formValue.optionName,
                                "customerOptionName": this.defectSaveEnable ? '' : formValue.customerOptionName,
                            },
                            defectOption,
                            "addOn": 'true',
                            "lastPageNumber": pageNumber
                        }
                        this.saveProposalOption(option)
                    }
				}
				else {
					option = {
						"opportunityId": opportunityIdVal,
                        'opportunityProposalId': opportunityProposalIdVal,
						"selectedTemplate": selectedType,
						"proposalTemplateId": proposalTemplatesIdVal,
						"setupOptionId": setupOptionIdVal,
						"optionTemplateId": formValue.optionName,
                        "customerOptionName": formValue.customerOptionName,
						"addOn": 'true',
						"lastPageNumber": pageNumber
					}
					this.saveProposalOption(option)
				}
			}
			else {
				let addOnName = this.addonForm.controls.optionName.value;
                const customerOptionName =  this.addonForm.controls.customerOptionName.value;
				let addOnDetails = {
					addOnName: addOnName,
					addOnId: this.selectedAddon.addOnId,
                    customerOptionName: customerOptionName
				};
				this.updateAddOn(addOnDetails);
			}
		}
	}
	updateAddOn(addOnDetails) {
		this.optionTemplateService.editAddOns(addOnDetails).subscribe(data => {
			this.action = 'save';
            if(!this.freemiumAccess){
                let msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
			this.onClose.next(true);
			this.bsModalRef.hide();
		}, error => {
			console.log('err', error);
		})
	}
	//save Proposal Options
	saveAddon(option) {
		this.optionTemplateService.addProposalOptions(option).subscribe(data => {
            let contentPageId = '';
            if ( data ) {
                if ( data.hasOwnProperty('contentPageId')) {
                    contentPageId = data['contentPageId'];
                }
            }
            if(!this.freemiumAccess){
                let msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
			this.action = 'saving';
			this.onClose.next({ added: true, type: this.addonType, contentPageId: contentPageId });
			this.bsModalRef.hide();
		}, error => {
			console.log('err', error);
		})
	}

	//save Proposal Options
	saveProposalOption(option) {
		this.optionTemplateService.addOrLinkAddOns(option).subscribe(data => {
			this.proposalTemplateService.setSectionData(data);
			this.action = 'saving';
            if(!this.freemiumAccess){
                let msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
			this.onClose.next({ added: true, type: this.showAddOnTemplate ? this.addonType : 'blank' });
			this.bsModalRef.hide();
		}, error => {
			console.log('err', error);
		})
	}
	// Select option
	optionSelected(event) {
		this.addonForm.reset();
		this.addonType = event;
		if (this.select2 == false) {
			setTimeout(() => {
				$('select.addon-select2').select2();
			}, 500);
			this.select2 = true;
		}
        if(event == 'blank'){
            this.blankOption = true;
            this.addMarketPlaceOption = false;
            setTimeout(() => {
                $('.blank-image').addClass('selected-image');
            },200)
        }
	}

    templateSelected(event) {
        this.addonForm.controls['optionName'].setValue(event.templateId);
    }

    addBlankOption(event){
        this.blankOption = true;
        this.addMarketPlaceOption = false;
        this.addonForm.controls['optionName'].setValue('');
        this.addonForm.controls['customerOptionName'].setValue('');
        $('.image-styles').removeClass('selected-image');
        $('.blank-image').addClass('selected-image');
    }

    addOption(event, data) {
        this.addonData = [];
        this.addonForm.controls['customerOptionName'].setValue('');
        if(event.target.closest('.image-styles')){
            this.blankOption = false;
            this.addMarketPlaceOption = true;
            $('.blank-image').removeClass('selected-image');
            $('.image-styles').removeClass('selected-image');
            event.target.classList.add('selected-image');
            this.addonData = data;
            this.addonForm.controls['optionName'].setValue(data['name']);
            return;
        }
    }

    saveMarketplaceOption(option){
        let data = this.addonData;
        let makePostData = {
            'templatesId' : data['templatesId'],
            'templatesList' : data['templateType'],
            'filename' : data['fileName'],
            'freemium': false,
            'parentId': null,
            'optionType': 'blank',
            'templateId': this.opportunityProposalId ? this.opportunityProposalId : this.template.id,
            'screen': this.opportunityProposalId ? 'opportunity' : 'proposal',
            'data': option,
        }
        this.proposalTemplateService.manipulatemarketTemplates(makePostData).subscribe((data: any) => {
            let contentPageId = true;
            this.onClose.next(contentPageId);
            if(!this.freemiumAccess){
                let msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
            this.bsModalRef.hide();
        });
    }

    ngOnDestroy() {
        for (let subscription in this.subscriptions) {
            this.subscriptions[subscription].unsubscribe();
        }
    }

}
